import React from 'react';
import { Icons } from './Icons';

interface HeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onAddPatient: () => void;
  onBookAppointment: () => void;
  showAddPatient?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  searchQuery,
  onSearchChange,
  onAddPatient,
  onBookAppointment,
  showAddPatient = true,
}) => {
  return (
    <header className="bg-white border-b border-slate-200 flex flex-col md:flex-row md:items-center md:justify-between gap-3 px-6 py-4">
      <div className="relative w-full md:w-96">
        <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
          <Icons.Search />
        </div>
        <input
          type="text"
          placeholder="Search patients..."
          className="w-full pl-12 pr-4 py-3 bg-slate-50 border-none rounded-2xl text-sm focus:ring-2 focus:ring-blue-500"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <div className="flex flex-wrap gap-2 md:justify-end">
        {showAddPatient && (
          <button
            onClick={onAddPatient}
            className="px-5 py-2.5 bg-white border border-slate-200 text-slate-600 font-bold text-sm rounded-xl hover:bg-slate-50"
          >
            + Add Patient
          </button>
        )}
        <button
          onClick={onBookAppointment}
          className="px-5 py-2.5 bg-blue-600 text-white font-bold text-sm rounded-xl shadow-lg hover:bg-blue-700"
        >
          + Book Appointment
        </button>
        {/* <button
          type="button"
          onClick={onLogout}
          className="px-3 py-2 rounded-xl border text-xs font-bold hover:bg-slate-50"
        >
          Logout
        </button> */}
      </div>
    </header>
  );
};
